import L from 'leaflet';

declare module 'leaflet' {
  interface MapOptions {
    rotate?: boolean;
    bearing?: number;
    touchRotate?: boolean;
    shiftKeyRotate?: boolean;
    rotateControl?: boolean | {closeOnZeroBearing?: boolean; position?: string};
  }

  interface Map {
    setBearing(theta: number): void;
    getBearing(): number;
  }
}

(globalThis as typeof globalThis & {L: typeof L}).L = L;
